import { useSelector } from 'react-redux';
import { getFeatureFlag } from 'selectors';
import { AUTO_ENABLED_FLAGS, AUTO_DISABLED_FLAGS } from 'constants/featureFlags';
import env from '@beam-australia/react-env';

const ENABLE_FEATURE_FLAG_OVERRIDE = env('ENABLE_FEATURE_FLAG_OVERRIDE') === 'true';

export const featureEnabled = (flagName) => {
  if (ENABLE_FEATURE_FLAG_OVERRIDE && AUTO_ENABLED_FLAGS.includes(flagName)) {
    return true;
  }

  return useSelector(getFeatureFlag(flagName));
};

export const featureDisabled = (flagName) => {
  if (ENABLE_FEATURE_FLAG_OVERRIDE && AUTO_DISABLED_FLAGS.includes(flagName)) {
    return true;
  }

  return !featureEnabled(flagName);
};

export default featureEnabled;
